
import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { injectIntl, FormattedMessage } from 'react-intl'

import * as loaderActions from '../../../Core/Loader/loader.actions'

import * as firebaseSelectors from '../../../Core/Firebase/firebase.selectors'

const NewSessionPopup = ({ removeLoader, groupData: { session } }) => (
  <div className="endsession" style={{ zIndex: 20, backgroundColor: 'white' }}>
    <div className="endsession--title">
      <FormattedMessage id={'popups.newSession.title'} />
    </div>
    <div className="endsession--hour">00:00:00</div>
    <div className="endsession--text">
      <FormattedMessage id={'popups.newSession.text'} values={{ session: session - 1 }} />
    </div>
    <div className="btn--orange" onClick={() => removeLoader('session_ended_loader')}>
      <span className="icon-rocket"> </span>
      <span>
        <FormattedMessage id={'popups.newSession.accept'} />
      </span>
    </div>
  </div>
)

const mapStateToProps = (state) => ({
  groupData: firebaseSelectors.getGroupData(state),
})

const mapDispatchToProps = (dispatch) => ({
  removeLoader: bindActionCreators(loaderActions.removeLoader, dispatch),
})

NewSessionPopup.propTypes = {
  removeLoader: PropTypes.func,
  groupData: PropTypes.object,
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(NewSessionPopup))
